import { render, staticRenderFns } from "./DayGridMonth.vue?vue&type=template&id=09bb0fb8"
import script from "./DayGridMonth.vue?vue&type=script&lang=js"
export * from "./DayGridMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09bb0fb8')) {
      api.createRecord('09bb0fb8', component.options)
    } else {
      api.reload('09bb0fb8', component.options)
    }
    module.hot.accept("./DayGridMonth.vue?vue&type=template&id=09bb0fb8", function () {
      api.rerender('09bb0fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/planner/calendar/view/DayGridMonth.vue"
export default component.exports